import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
import { TranslationKeys } from '~/common/types';

export const S2S_FLOW_TYPES = ['TYRES_ORDER', 'SEARCH_QUOTES'] as const;
export const S2S_ACTIVE_STATUSES = ['ACTIVE', 'INACTIVE'] as const;

export const s2sFlowFormSchema = z.object({
  type: z.enum(S2S_FLOW_TYPES),
  partner: z.string().nullable().optional(),
  status: z.enum(S2S_ACTIVE_STATUSES),
  url: z.string().nullable().optional(),
});

export const s2sFlowTemplateFormSchema = z.object({
  name: requiredString,
  criteria: z
    .array(
      z.object({
        criterion: z.object({ id: z.string() }),
        values: z.array(requiredString).min(1, { message: REQUIRED_MESSAGE }),
      }),
    )
    .min(1, { message: REQUIRED_MESSAGE }),
  flows: z.array(s2sFlowFormSchema),
  businessRuleCodes: z.array(z.string()),
  newFlowType: z.string().optional(),
  newFlowPartner: z.string().optional(),
});

const s2sBusinessRuleLabelSchema = z.object({
  defaultValue: z.string(),
  i18nKey: z.custom<keyof TranslationKeys>(),
});

export const s2sBusinessRuleSchema = z.object({
  id: z.string(),
  name: s2sBusinessRuleLabelSchema,
  description: s2sBusinessRuleLabelSchema,
  code: z.string(),
});

const embeddedBusinessRuleSchema = z.object({
  code: z.string(),
  name: s2sBusinessRuleLabelSchema,
  description: s2sBusinessRuleLabelSchema,
});

export const s2sFlowTemplatePayloadSchema = s2sFlowTemplateFormSchema
  .omit({
    criteria: true,
    businessRuleCodes: true,
    newFlowType: true,
    newFlowPartner: true,
  })
  .extend({
    criteria: z.array(
      z.object({
        criterion: z.object({ id: z.string() }),
        values: z.array(
          z.object({
            id: z.string(),
            label: z.string(),
          }),
        ),
      }),
    ),
    businessRules: z.array(embeddedBusinessRuleSchema),
  });

export const s2sFlowTemplateSchema = s2sFlowTemplatePayloadSchema.extend({
  id: z.string(),
  status: z.enum(S2S_ACTIVE_STATUSES),
});
